import { useEffect } from 'react';

import { useGetContext } from '../../api/lendingApi/lendingApiQueries';
import { useLocale } from '../../hooks/useLocale';
import { getRuntimeEnvironment } from '../../utils/getRuntimeEnvironment';

// Public app id (it appears in the widget URL and cookie names). Kept here
// rather than read from context, so the launcher works before there's a session.
const APP_ID = {
  production: 'zmy6hal3',
  staging: 'hl34wnki',
};

export const Intercom = () => {
  const { context, isContextLoading } = useGetContext();
  const { isUK } = useLocale();

  const jwt = context?.user_intercom_jwt;
  const appId = APP_ID[getRuntimeEnvironment()];

  const canBoot =
    isUK && !isContextLoading && context?.logged_in_user_type !== 'staff';

  useEffect(() => {
    if (!canBoot) return;

    if (window.Intercom) {
      if (jwt) window.Intercom('update', { intercom_user_jwt: jwt });
      return;
    }

    const queue: unknown[][] = [];
    const intercom = (...args: unknown[]) => {
      queue.push(args);
    };
    intercom.q = queue;
    window.Intercom = intercom;

    const script = document.createElement('script');
    script.async = true;
    script.setAttribute('data-ot-ignore', '');
    script.src = `https://widget.intercom.io/widget/${appId}`;
    document.head.appendChild(script);

    intercom('boot', {
      app_id: appId,
      cookie_consent: window.OnetrustActiveGroups?.includes('C0003')
        ? 'granted'
        : 'opt_in',
      custom_launcher_selector: '.ChatSupportButton',
      ...(jwt ? { intercom_user_jwt: jwt } : {}),
    });
  }, [canBoot, appId, jwt]);

  return null;
};
